module.exports = __webpack_public_path__ + "img/487.50465c26.jpg";